import React, { useState, useEffect } from "react";

import { Container, Row, Col, Form } from "react-bootstrap";
import api from "../../api";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import { checkPermissionStatus } from "helpers/utils";
import { encryptDataToArray } from "helpers/EncDec";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
const CreateVacancyType = props => {
  const history = useHistory();
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [statePayload, setStatePayload] = useState({});

  const handleInput = event => {
    const { name, value } = event.target;

    setStatePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
    setErrors(prevState => ({
      ...prevState,
      [name]: "",
    }));
  };

  const createNewVacancyType = async payload => {
    await api
      .post(
        `${process.env.REACT_APP_API_URL}/admin/vacancyType/create-vacancyType`,
        payload
      )
      .then(response => {
        setIsLoading(false);
        toast.success("Position Level created successfully");
        history.push("/vacancyType-list");
      })
      .catch(err => {
        setIsLoading(false);
        toast.error(err?.response?.data?.msg || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const validateForm = () => {
    let isValid = true;
    let error = {};

    console.log(statePayload, "statePayload");
    if (!statePayload?.title?.trim()) {
      error = {
        ...error,
        title: t(`vacancy_type.ValidationMsg`),
      };
      isValid = false;
    }
    if (!statePayload?.description?.trim()) {
      error = {
        ...error,
        description: t(`vacancy_type.ValidationMsg`),
      };
      isValid = false;
    }
    if (!statePayload?.status) {
      error = {
        ...error,
        status: t(`vacancy_type.ValidationMsg`),
      };
      isValid = false;
    }
    if (!statePayload?.sequence) {
      error = {
        ...error,
        sequence: t(`vacancy_type.ValidationMsg`),
      };
      isValid = false;
    }
    setErrors(error);
    return isValid;
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);

    const isValid = validateForm();

    if (!isValid) {
      setIsLoading(false);
      return false;
    }

    // setting payload to save inside the database;
    const reqData = {
      title: statePayload?.title?.trim(),
      description: statePayload?.description?.trim(),
      status: statePayload?.status,
      sequence: statePayload?.sequence,
    };
    const encryptedQuery = encryptDataToArray(reqData);

    let payload = new FormData();
    payload.append("reqData", JSON.stringify(encryptedQuery));

    // payload.append("title", statePayload?.title);
    // payload.append("description", statePayload?.description);
    // payload.append("status", statePayload?.status);
    // payload.append("sequence", statePayload?.sequence);

    // Calling the api and saving data;
    await createNewVacancyType(payload);
  };

 
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
 if (!checkPermissionStatus("job-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }
  return (
    <div className="page-content">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-1 align-items-center">
            <Col lg="6" md="6">
              <Link to="/vacancyType-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`vacancy_type.CreateVacancyType`)}
                </h5>
              </Link>
            </Col>

            {/* <Col lg="6" md="6">
              <div class="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/vacancyType-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy pt-2">
          {/* <div className="form-details-section heading">
            <div className="personal-heading">
              <h2 className="heading-two">Vacancy Details:</h2>
            </div>
            <p className="pb-1">Please fill in your vacancy details below</p>
          </div> */}
          <div className="form-details-section">
            <Row>
              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`vacancy_type.VacancyTypeName`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`vacancy_type.VacancyTypeName`)}
                  name="title"
                  value={statePayload?.title}
                  onChange={handleInput}
                  title={`Please enter ${t(`vacancy_type.VacancyTypeName`)}`}
                />
                {errors?.title && (
                  <small className="text-danger"> {errors?.title} </small>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`vacancy_type.Description`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`vacancy_type.Description`)}
                  name="description"
                  value={statePayload?.description}
                  onChange={handleInput}
                  title={`Please enter ${t(`vacancy_type.Description`)}`}
                />
                {errors?.description && (
                  <small className="text-danger"> {errors?.description} </small>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`vacancy_type.SelectStatus`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="status"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  // onChange={handleInput}
                  // title={t(
                  //   `vacancy_type.${
                  //     selectedValue === "1" ? "Active" : "Inactive"
                  //   }`
                  // )}

                  onChange={e => {
                    e.target.setAttribute(
                      "title",
                      e.target.options[e.target.selectedIndex].text
                    );
                    handleInput(e);
                  }}
                  title={t(`vacancy_type.SelectStatus`)}
                >
                  <option value="" defaultValue>
                    {t(`vacancy_type.SelectStatus`)}
                  </option>
                  <option value="1"> {t(`vacancy_type.Active`)}</option>
                  <option value="0"> {t(`vacancy_type.Inactive`)}</option>
                </select>
                {errors?.status && (
                  <small className="text-danger"> {errors?.status} </small>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`vacancy_type.Sequence`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="sequence"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  // onChange={handleInput}
                  // title={`Please select ${t(`vacancy_type.Sequence`)}`}
                  onChange={e => {e.target.setAttribute("title", e.target.value);handleInput(e);}}
                  title={`Please select ${t(`vacancy_type.Sequence`)}`}
                >
                  <option disabled selected>
                    {t(`vacancy_type.SelectSequence`)}
                  </option>
                  {[...Array(15)].map((_, index) => (
                    <option key={index + 1} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
                {errors?.sequence && (
                  <small className="text-danger"> {errors?.sequence} </small>
                )}
              </Form.Group>
            </Row>

            <Form.Group className="cta text-center d-flex justify-content-start gap-3 mt-4 pb-3">
              <Link to="/vacancyType-list" className="btn btn-secondary">
                {t(`vacancy_type.Cancel`)}
              </Link>
              <ButtonLoader
                title={t(`vacancy_type.SaveDetails`)}
                variant="primary"
                type="submit"
                loading={isLoading}
                message={"Saving"}
                onClick={e => {
                  handleSubmit(e);
                }}
              />
            </Form.Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CreateVacancyType;
